import {
  DoctorLicencePlanType,
  DoctorLicencePricing,
  DoctorLicencePricingUpdateRequest,
} from "../types/doctorLicencePricing.definition";
import {
  getAllDoctorLicencePricing,
  updateDoctorLicencePricing,
  updateDoctorLicencePricingEnabled,
} from "../webclients/doctorLicencePricing.client";

export const doctorLicencePricingApi = {
  getAll: async (): Promise<DoctorLicencePricing[]> => {
    const response = await getAllDoctorLicencePricing();
    return response.data;
  },
  update: async (
    id: number,
    data: DoctorLicencePricingUpdateRequest
  ): Promise<DoctorLicencePricing> => {
    const response = await updateDoctorLicencePricing(id, data);
    return response.data;
  },
  updateEnabled: async (
    planType: DoctorLicencePlanType,
    enabled: boolean
  ): Promise<DoctorLicencePricing> => {
    const response = await updateDoctorLicencePricingEnabled(planType, {
      enabled,
    });
    return response.data;
  },
};
